import React from "react";
import { PayrollFrequencyContainer } from "../../containers";

const PayrollFrequency = (props) => {
  return <PayrollFrequencyContainer {...props} />;
};

export default PayrollFrequency;
